import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { useSetActiveEventPanelTab } from '../active-event-panel-tab-provider';
import { useSelectedLocation } from '../tabs/hooks/use-selected-location';
import { useEventMetadataStore } from './event-metadata';

const useSetMergedEventsTabActiveWhenLocationChangesInNewEvent = () => {
    const selectedLocation = useSelectedLocation();
    const setActiveEventPanelTab = useSetActiveEventPanelTab();
    const eventMetadata = useEventMetadataStore().state.metadata;
    const eventId = eventMetadata?.eventId;

    useEffect(() => {
        if (!eventId && selectedLocation && !selectedLocation.isForcedResult) {
            setActiveEventPanelTab('MERGED_EVENTS');
        }
    }, [selectedLocation, setActiveEventPanelTab, eventId]);
};

/**
 * General hook to perform any kind of side-effects
 * as a result of interacting with the event panel form
 */
export function useEventPanelFormSideEffects(_eventForm: UseFormReturn<EventPanelFormType>): void {
    useSetMergedEventsTabActiveWhenLocationChangesInNewEvent();
}
